import React, {useState, useEffect, useContext, useReducer} from 'react';
import {Link} from 'react-router-dom';
import headerImage from '../../../assets/images/header-icon.png';
import LogoHeader from '../../../assets/images/Logo-header.svg';
import axios from 'axios';
import Cookies from 'js-cookie';
import {baseApiCore} from '../../Constants';
import Button from 'react-bootstrap/Button';
import Container from 'react-bootstrap/Container';
import Form from 'react-bootstrap/Form';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import Offcanvas from 'react-bootstrap/Offcanvas';
import {Fab, Typography} from "@mui/material";
import AccountBoxIcon from '@mui/icons-material/AccountBox';
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import './HeaderComponent.scss'

const HeaderComponent = (props) => {
    const [showButton, setShowButton] = useState(true)
    const [showServent, setShowServent] = useState(true)
    const [showAuthentication, setShowAuthentication] = useState(false)
    const [token, setToken] = useState(Cookies.get('auth'))
    
    // const token = Cookies.get('auth');

    const getRoles = () => {

        axios.get(`${baseApiCore}authentication/GetRoles`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            },
        })
            .then(response => {
                const Servent = response.data.content.some((item) => item === 'Servent');
                const User = response.data.content.some((item) => item === 'User');
                if (User === true) {
                    setShowButton(false)
                }
                if (Servent === true) {
                    setShowServent(false)
                }
                if(Servent && User ===true){
                    setShowServent(false)
                    setShowButton(true)
                }
            })
            .catch(error => {
                console.log('notOkGetRole');
            });
    }


    useEffect(() => {
        if (token) {
            getRoles();
            setShowAuthentication(true)
        }

    }, [token]);

    const expand = 'lg'

    return (
//         <div className='baseTemplate-header col-12' >
//             {/* <div className='col-md-4 col-12'> */}
//             <Navbar key={expand} bg="transparent" expand={expand} className="col-12" collapseOnSelect>
//                 <Container fluid>
//                     <Navbar.Toggle aria-controls={`offcanvasNavbar-expand-${expand}`}/>
//
//                     <Navbar.Brand className='col-6 navbarBrand-xs '>
//                         <div className='HeaderComponent-headerImage-xs'>
//                             <img src={headerImage} alt=""/>
//                         </div>
//                     </Navbar.Brand>
//
//                     <Navbar.Offcanvas
//                         id={`offcanvasNavbar-expand-${expand}`}
//                         aria-labelledby={`offcanvasNavbarLabel-expand-${expand}`}
//                         placement="end"
//                         className='NavbarOffcanvas-body'
//                     >
//                         <Offcanvas.Header >
//                             <Offcanvas.Title id={`offcanvasNavbarLabel-expand-${expand}`}>
//                                 خورشید پیشوا
//                             </Offcanvas.Title>
//                         </Offcanvas.Header>
//                         <Offcanvas.Body>
//                             <Nav className="col-md-5  HeaderComponent-LogoHeader">
//                                 <Link to={'*'} className="nav-item " >
//                                     <Nav.Link className="nav-link" href='*'>صفحه اصلی</Nav.Link>
//                                 </Link>
//                                 <Link to={'/ShrineNews'} className="nav-item " >
//                                     <Nav.Link className="nav-link" href='/ShrineNews'>اخبار حرم</Nav.Link>
//                                 </Link>
//                                 <Link to={'/PilgrimServices'} className="nav-item " hidden={showButton}>
//                                     <Nav.Link className="nav-link" href='/PilgrimServices'>ثبت نام خادم</Nav.Link>
//                                 </Link>
//                                 <Link to={'/ServantServices'} className="nav-item " hidden={showServent}>
//                                     <Nav.Link className="nav-link" href='/ServantServices'>اخبار خادمین</Nav.Link>
//                                 </Link>
//                                 <Link to={'/ShrineInformation/AboutImamzadeh'} className="nav-item " >
//                                     <Nav.Link className="nav-link" href='/ShrineInformation/AboutImamzadeh'>درباره امام
//                                         زاده</Nav.Link>
//                                 </Link>
//                                 <Link to={'/Authentication'} className="nav-item login-signUp-xs " hidden={showAuthentication} >
//                                     <Nav.Link className="nav-link" href='/Authentication'>ورود / ثبت نام</Nav.Link>
//                                 </Link>
//
//                             </Nav>
//                             <Navbar.Brand className='col-md-2'>
//                                 <div className='HeaderComponent-headerImage'>
//                                     <img src={headerImage} alt=""/>
//                                 </div>
//                             </Navbar.Brand>
//                             <div className='col-md-5 HeaderComponent-LogoHeader'>
//
//                                 <Link to={'/Authentication'}>
//                                     {/*<span className=''>ورود / ثبت نام</span>*/}
//                                     <Fab variant="extended" size={"small"} color={'info'} className='mx-4'>
//                                         <Typography fontFamily={"iranSanse-medium"} fontSize={10} className='d-none d-sm-block'>
//                                             ورود/ثبت نام
//                                         </Typography>
//                                         <AccountBoxIcon></AccountBoxIcon>
//                                     </Fab>
//                                 </Link>
//                                 <img className='header-logo' src={LogoHeader} alt=""/>
//                             </div>
//                         </Offcanvas.Body>
//                     </Navbar.Offcanvas>
//                 </Container>
//             </Navbar>
//             {/* <nav className="navbar navbar-expand-lg navbar-light">
//    <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
//     <span className="navbar-toggler-icon"></span>
//   </button>
//   <div className="collapse navbar-collapse" id="navbarSupportedContent">
//     <ul className="navbar-nav mr-auto">
//     <Link to={'*'}>
//       <li className="nav-item active">
//         <a className="nav-link" href="#">صفحه اصلی</a>
//       </li>
//       </Link>
//       <Link to={'/ShrinePlane'}>
//       <li className="nav-item active">
//         <a className="nav-link" href="#">اخبار صحن</a>
//       </li>
//       </Link>
//       <Link to={'/ShrineInformation/AboutImamzadeh'}  >
//       <li className="nav-item active">
//         <a className="nav-link" href="#">زندگی نامه حضرت</a>
//       </li>
//       </Link>
//       <Link to={'/PilgrimServices'} hidden={showButton}>
//       <li className="nav-item active">
//         <a className="nav-link" href="#">ثبت نام خدام</a>
//       </li>
//       </Link>
//     </ul>
//   </div>
// </nav> */}
//             {/* </div> */}
//             {/* <div className='HeaderComponent-headerImage col-md-4 '>
// <img src={headerImage} alt="" />
// </div>
// <div className='col-md-4 HeaderComponent-LogoHeader p-md-4'>
//     <div className='login-signUp p-md-4'>
//     <Link to={'/Authentication'}>
//         <span className='p-md-4'>ورود/ثبت نام</span>
//     </Link>
//     </div>
// <img src={LogoHeader} alt="" />
// </div> */}
//         </div>
        <Row className="pt-2 g-0 baseTemplate-header"  style={{height: "50px"}}>
            <Col xl={4} md={4} sm={4} xs={3} style={{paddingRight: "30px"}}>
                <Row>
                    <Col>
                        {/*<div className='HeaderComponent-LogoHeader'>*/}

                        <img src={LogoHeader} alt="" className="logo360" height={42}/>
                        {/*</div>*/}
                    </Col>
                    <Col>
                        <div style={{backgroundColor: 'red'}}>
                            {/*<DateToday></DateToday>*/}
                        </div>

                    </Col>
                </Row>

            </Col>
            <Col xl={4} md={4} sm={4} xs={6} className="d-flex justify-content-center">
                <img src={headerImage} alt="" height={60} className="HeaderImg"/>
            </Col>
            <Col className="d-flex justify-content-end px-4" xl={4} md={4} sm={4} xs={3}>
                <div>
                    <Link to={'/Authentication'}>
                        <Fab variant="extended" size={"small"} className='colorbtnlogin'>
                            <Typography fontFamily={"iranSanse-medium"} fontSize={10} className='d-none d-sm-block'>
                                ورود/ثبت نام
                            </Typography>
                            <AccountBoxIcon></AccountBoxIcon>
                        </Fab>
                        {/*<span className='p-1'>ورود/ثبت نام</span>*/}
                    </Link>
                </div>
            </Col>
            {/*<div className='baseTemplate-header'>*/}
            {/*    <div className='col-md-4'>*/}
            {/*        <nav className="navbar navbar-expand-lg navbar-light">*/}
            {/*            <div className="collapse navbar-collapse" id="navbarSupportedContent">*/}
        </Row>
    );
};

export default HeaderComponent;